import type {
  InputHTMLAttributes,
  LabelHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import { cn } from "../../lib/cn.js";

const fieldClassName =
  "focus-ring w-full rounded-xl border border-border-default bg-surface-input px-4 py-2.5 text-sm text-content-primary transition-[border-color,box-shadow] focus:border-accent motion-reduce:transition-none";

export function Label({ className, children, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label className={cn("block text-sm font-medium text-content-primary mb-1.5", className)} {...props}>
      {children}
    </label>
  );
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export function Input({ className, ...props }: InputProps) {
  return (
    <input
      className={cn(fieldClassName, "placeholder:text-content-muted", className)}
      {...props}
    />
  );
}

export function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select className={cn(fieldClassName, className)} {...props}>
      {children}
    </select>
  );
}

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cn(fieldClassName, "placeholder:text-content-muted min-h-[100px]", className)}
      {...props}
    />
  );
}

export function FieldHelp({ className, children, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn("text-xs text-content-muted mt-1.5", className)} {...props}>
      {children}
    </p>
  );
}

export function FieldError({ className, children, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn("text-xs text-status-rejected-text mt-1.5", className)} {...props}>
      {children}
    </p>
  );
}
